import { FC } from "react";
import { LotStatuses } from "../../api/dtos";
import { ListItemText, MenuItem, TextField } from "@mui/material";

interface ILotStatusFilterSelectProps {
    selectedLotStatus: LotStatuses | undefined,
    setSelectedLotStatus: React.Dispatch<React.SetStateAction<LotStatuses | undefined>>
}

const LotStatusFilterSelect: FC<ILotStatusFilterSelectProps> = ({
    selectedLotStatus,
    setSelectedLotStatus
}) => {
    
    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newValue = !Number.isNaN(Number(event.target.value)) ? Number(event.target.value) : undefined;
        setSelectedLotStatus(newValue)
    }

    return (
        <TextField
            sx={{
                width: 200
            }}
            select
            label={"Lot Sale Status"}
            onChange={handleChange}
            value={selectedLotStatus ?? ""}
        >
            <MenuItem key={""} value={""}><ListItemText primary={"All"} /></MenuItem>
            <MenuItem key={LotStatuses.Available} value={LotStatuses.Available}><ListItemText primary={"Available"} /></MenuItem>
            <MenuItem key={LotStatuses.ComingSoon} value={LotStatuses.ComingSoon}><ListItemText primary={"Coming Soon"} /></MenuItem>
            <MenuItem key={LotStatuses.ContractExchanged} value={LotStatuses.ContractExchanged}><ListItemText primary={"Contract Exchanged"} /></MenuItem>
            <MenuItem key={LotStatuses.ContractIssued} value={LotStatuses.ContractIssued}><ListItemText primary={"Contract Issued"} /></MenuItem>
            <MenuItem key={LotStatuses.ContractSettled} value={LotStatuses.ContractSettled}><ListItemText primary={"Contract Settled"} /></MenuItem>
            <MenuItem key={LotStatuses.DisplayHome} value={LotStatuses.DisplayHome}><ListItemText primary={"Display Home"} /></MenuItem>
            <MenuItem key={LotStatuses.Englobo} value={LotStatuses.Englobo}><ListItemText primary={"Englobo"} /></MenuItem>
            <MenuItem key={LotStatuses.Future} value={LotStatuses.Future}><ListItemText primary={"Future"} /></MenuItem>
            <MenuItem key={LotStatuses.OnHold} value={LotStatuses.OnHold}><ListItemText primary={"On Hold"} /></MenuItem>
            <MenuItem key={LotStatuses.SalesAdviceIssued} value={LotStatuses.SalesAdviceIssued}><ListItemText primary={"Sales Advice Issued"} /></MenuItem>
            <MenuItem key={LotStatuses.Unavailable} value={LotStatuses.Unavailable}><ListItemText primary={"Unavailable"} /></MenuItem>
        </TextField>
    );
}

export default LotStatusFilterSelect;